import { useState } from 'react';
import apiService from '../../axios/apiService';

const usePaymentTransactionOrder = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const createOrder = async (recordId, paymentFor) => {
    // Create order
    try {
      setLoading(true);
      const response = await apiService.paymentTransactionCreateOrder({
        recordId,
        paymentFor
      });
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Error on create order : ', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  const completeOrder = async (orderId) => {
    // Complete order
    try {
      setLoading(true);
      const response = await apiService.paymentTransactionCompleteOrder({
        orderId,
      });
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Error on complete order : ', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const cancelOrder = async (orderId) => {
    // Cancel order
    try {
      setLoading(true);
      const response = await apiService.paymentTransactionCanceOrder({
        orderId,
      });
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Error on cancel order : ', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    createOrder,
    completeOrder,
    cancelOrder,
  };
};

export default usePaymentTransactionOrder;
